<template>
    <div class="mt-2 mb-2 w-full relative bg-gray-50">
        <label for="default" class="text-left block mb-2 text-lg font-semibold text-gray-900 ">
            {{ label }}
        </label>



        <div class="mt-4 flex items-center justify-start w-8/12">

            <label class="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" id="toggle-sync" class="sr-only peer" v-model="google_synchro"
                    :disabled2="($route?.params?.rid != user?._id)">
                <div class="w-11 h-6 bg-gray-300 rounded-full peer peer-checked:bg-blue-600 after:absolute 
                      after:top-0.5 after:left-[2px] after:bg-white after:border after:rounded-full 
                      after:h-5 after:w-5 after:transition-transform peer-checked:after:translate-x-full">
                </div>
            </label>
            <span class="ml-4 text-sm font-medium text-gray-900">Activer la Synchronisation avec Google Drive</span>
        </div>

        <!-- Connexion Google -->
        <div class="mt-4 flex items-center space-x-4">
            <button class="flex items-center px-4 py-2 border rounded-lg text-gray-700 "
                :class="{'hover:bg-gray-100': google_synchro == true, 'hidden' : google_connected}"
                :disabled="(google_synchro != true)" id="google-login" @click="getGoogleOAuth2URL($event)">
                <img src="https://www.svgrepo.com/show/355037/google.svg" alt="Google" class="w-5 h-5 mr-2"
                    :class="{'grayscale opacity-50' : google_synchro != true}">

                Se connecter
            </button>
            <button class="flex items-center px-4 py-2 border rounded-lg text-gray-700 "
                :class="{'hover:bg-gray-100': google_synchro == true, 'hidden' : !google_connected}"
                :disabled="(google_synchro != true)" id="google-login" @click="disconnect($event)">
                <img src="https://www.svgrepo.com/show/355037/google.svg" alt="Google" class="w-5 h-5 mr-2"
                    :class="{'grayscale ' : google_synchro != true}">

                Se déconnecter
            </button>


            <span id="status" class="text-sm text-gray-500" :class="{'hidden' : google_connected}">Non connecté</span>
            <span id="status" class="text-sm text-gray-500" :class="{'hidden' : !google_connected}">Connecté - jusqu'a
                {{timestampToISO(google_expiry_date)}} (reconnexion automatique)</span>
        </div>
        <!-- Options de Synchronisation -->
        <div class="w-full border-gray-400 border-b my-3 "></div>

        <div class="mt-3 flex items-center justify-between">
            <span class="text-lg font-medium  "
                :class="{'text-gray-400' :(google_synchro != true) || (google_connected != true), 'text-gray-800' :(google_synchro == true) && (google_connected == true) }">Documents
                des Entités à Synchroniser</span>

        </div>

        <div class="mt-2  flex flex-row items-center justify-start">
            <label class="flex items-center space-x-3 mr-4 " v-for="entity in entities" :key="entity.id">
                <input v-model="scopes.entity_id[entity.id]" type="checkbox" class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded 
                 focus:ring-blue-500" :disabled="(google_synchro != true) || (google_connected != true)"
                    id="sync-bons">
                <span
                    :class="{'text-gray-400' :(google_synchro != true) || (google_connected != true), 'text-gray-700' :(google_synchro == true) && (google_connected == true) }">{{entity?.name}}</span>
            </label>



        </div>

        <div class="mt-6 flex items-center justify-between">
            <span class="text-lg font-medium "
                :class="{'text-gray-400' :(google_synchro != true) || (google_connected != true), 'text-gray-800' :(google_synchro == true) && (google_connected == true) }">Type
                de Documents à Synchroniser</span>

        </div>

        <div class="mt-2 space-y-3">
            <label class="flex items-center space-x-3">
                <input v-model="options.delivery_report" type="checkbox" class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded 
                 focus:ring-blue-500" :disabled="(google_synchro != true) || (google_connected != true)"
                    id="sync-bons">
                <span
                    :class="{'text-gray-400' :(google_synchro != true) || (google_connected != true), 'text-gray-700' :(google_synchro == true) && (google_connected == true) }">Synchroniser
                    les Bons d'Arrivage</span>
            </label>

            <label class="flex items-center space-x-3">
                <input v-model="options.batch_report" type="checkbox" class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded 
                 focus:ring-blue-500" :disabled="(google_synchro != true) || (google_connected != true)"
                    id="sync-bons">
                <span
                    :class="{'text-gray-400' :(google_synchro != true) || (google_connected != true), 'text-gray-700' :(google_synchro == true) && (google_connected == true) }">Synchroniser
                    les Lots</span>
            </label>


            <label class="flex items-center space-x-3">
                <input v-model="options.invoice" type="checkbox" class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded 
                 focus:ring-blue-500" :disabled="(google_synchro != true) || (google_connected != true)"
                    id="sync-factures">
                <span class=" "
                    :class="{'text-gray-400' :(google_synchro != true) || (google_connected != true), 'text-gray-700' :(google_synchro == true) && (google_connected == true) }">Synchroniser
                    les Factures d'Achat</span>
            </label>

            <label class="flex items-center space-x-3">
                <input v-model="options.temperature_report" type="checkbox" class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded 
                 focus:ring-blue-500" :disabled="(google_synchro != true) || (google_connected != true)"
                    id="sync-temp">
                <span
                    :class="{'text-gray-400' :(google_synchro != true) || (google_connected != true), 'text-gray-700' :(google_synchro == true) && (google_connected == true) }">Synchroniser
                    les relevés de Températures</span>
            </label>

            <label class="flex items-center space-x-3">
                <input type="checkbox" v-model="options.cleaning_report" class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded 
                 focus:ring-blue-500" :disabled="(google_synchro != true) || (google_connected != true)"
                    id="sync-nettoyage">
                <span
                    :class="{'text-gray-400' :(google_synchro != true) || (google_connected != true), 'text-gray-700' :(google_synchro == true) && (google_connected == true) }">Synchroniser
                    les suivis de Nettoyage</span>
            </label>
        </div>

        <!-- Bouton Synchronisation Complète -->
        <div class="mt-6 w-64">
            <button @click="launchDataSynchronization($event)" class="w-full px-4 py-2 text-white bg-blue-600 rounded-lg 
                       hover:bg-blue-700 disabled:bg-gray-300" id="sync-button"
                :disabled="(google_synchro != true) || (google_connected != true)">
                Lancer une synchronisation complète
            </button>
        </div>
        <GoogleDriveSynchroModal @close="OnGoogleDriveSynchroClose" @confirm="OnGoogleDriveSynchroConfirm" />


    </div>


</template>
<script>

    import service from "@/services/FullService.vue"
    import GoogleDriveSynchroModal from '@/components/modals/GoogleDriveSynchroModal.vue'
    import { Modal } from 'flowbite';


    import { mapGetters } from "vuex";
    export default {
        name: 'ContentGoogleSynchro',
        props: {
            id: String,
            label: String,
            placeholder: String,
            required: Boolean,
            value: String,
            source: String,
            mode: String,
            filters: String,
            config: Object
        },
        async mounted() {

            let data = await service.getGoogleOAuth2Information(this.user.token)


            this.google_connected = data?.connected
            this.google_synchro = data?.activated
            this.google_expiry_date = data?.expiry_date


            if (data?.options == undefined)
                this.options = { invoice: true, delivery_report: true, batch_report: true, temperature_report: true, cleaning_report: true }
            else this.options = data?.options


            let f = { entity_id: { "66a4a19c8d43c894c147758a": false, "66a4a1cb8d43c894c147758b": false } }


            for (let i = 0; i < data?.filters?.entity_id?.length; i++) {



                f.entity_id[data?.filters.entity_id[i]] = true

            }

            this.scopes = f



            const modalEl20 = document.getElementById('google-drive-synchro-modal');
            this.modalGoogleDriveSynchro = new Modal(modalEl20, {
                placement: 'center'
            });




            this.output = this.value;

        },
        computed: {
            ...mapGetters({ user: "StateUser" }),
            isLoggedIn: function () {
                return this.$store.getters.isAuthenticated;
            },
        },

        methods: {

            timestampToISO(timestamp, locale = "fr-FR") {

                if (timestamp == undefined) return ""
                // Vérifier si le timestamp est en secondes et le convertir en millisecondes si nécessaire
                if (timestamp.toString().length === 10) {
                    timestamp *= 1000; // Convertir en millisecondes
                }

                let str = timestamp.toString()
                try {
                    const date = new Date(timestamp);

                    
                    const options = {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        timeZoneName: "short"
                    };

                   
                    str = Intl.DateTimeFormat(locale, options).format(date);
                    //    str = date.toISOString();
                }
                catch (e) {
                    // console.log(e)
                }

                return str
            }
            ,
            OnGoogleDriveSynchroClose() {

                this.modalGoogleDriveSynchro.hide()
            },
            OnGoogleDriveSynchroConfirm(event) {


                let msg = {
                    type: 'google-full-synchro',
                    forced_mode: event.forced_mode
                }

                this.$emit("action", msg)
                this.modalGoogleDriveSynchro.hide()
            },

            async launchDataSynchronization(event) {
                event.preventDefault()

                await this.getData();

                this.modalGoogleDriveSynchro.show()
                //
            },

            async disconnect(event) {
                event.preventDefault()
                let data = await service.getGoogleOAuth2Logout(this.user.token)
                if (data.status == "OK") this.google_connected = false;
                
            },

            async getGoogleOAuth2URL(event) {
                event.preventDefault()
                let data = await service.getGoogleOAuth2URL(this.user.token)
                window.location = data.url
            },
            async getData() {

                let entity_ids = []
                let keys = Object.keys(this.scopes.entity_id)

                for (let i = 0; i < keys.length; i++) {
                    if (this.scopes.entity_id[keys[i]])
                        entity_ids.push(keys[i])
                }

                let body =
                {
                    options:
                    {
                        invoice: this.options?.invoice,
                        delivery_report: this.options?.delivery_report,
                        batch_report: this.options?.batch_report,
                        temperature_report: this.options?.temperature_report,
                        cleaning_report: this.options?.cleaning_report,
                    },
                    filters: { entity_id: entity_ids }

                }

                await service.updateGoogleSynchroInformation(this.user.token, body)
                return this.output;
            }
        },

        components: {
            GoogleDriveSynchroModal,
        },
        data() {
            return {
                options: {},
                scopes: { entity_id: {} },
                entities: [{ id: "66a4a19c8d43c894c147758a", name: "Nemrod Alsace" }, { id: "66a4a1cb8d43c894c147758b", name: "Nemrod Sologne" }],
                google_synchro: false,
                google_connected: false,
                google_expiry_date: "",
                modalGoogleDriveSynchro: null,
                output: null,
                choices: [],
                lg: "FR",
            }
        },
        watch: {
            value: async function (val) {

                let data = await service.getGoogleOAuth2Information(this.user.token)
                this.google_connected = data?.connected
                this.google_synchro = data?.activated
                this.google_expiry_date = data?.expiry_date


                if (data?.options == undefined) this.options = { invoice: true, delivery_report: true, batch_report: true, temperature_report: true, cleaning_report: true }
                else this.options = data?.options

                let f = { entity_id: { "66a4a19c8d43c894c147758a": false, "66a4a1cb8d43c894c147758b": false } }


                for (let i = 0; i < data?.filters?.entity_id?.length; i++) {



                    f.entity_id[data?.filters.entity_id[i]] = true

                }

                this.scopes = f




                this.output = val;
            },
            google_synchro: async function () {





            },
            config: async function () {

            }
        }
    }
</script>